export default "__VITE_ASSET__BQJq6jCt__"